import React from "react";

function Aries() {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 496.159 496.159"
      enableBackground="new 0 0 496.159 496.159"
    >
      <path
        fill="#F2B12F"
        d="M248.083,0.003C111.071,0.003,0,111.063,0,248.085c0,137.001,111.07,248.07,248.083,248.07
	c137.006,0,248.076-111.069,248.076-248.07C496.159,111.062,385.089,0.003,248.083,0.003z"
      />
      <path
        fill="#6D6256"
        d="M444.762,177.718C425.032,85.898,315,116.252,315,116.252c-47.807,11.383-56.913,65.26-56.913,65.26
	c1.518,16.188,38.954,37.942,38.954,37.942c18.719,7.588,24.282-9.106,24.282-9.106l14.67-26.812
	c18.213-24.789,36.425-18.718,36.425-18.718c0,8.6,11.129,53.625,11.129,53.625c7.588,20.236,2.023,64.249,2.023,64.249
	c-2.024,24.283,16.188,22.259,16.188,22.259c7.588-6.071,16.903-19.489,20.235-23.777c0.425-0.546,0.917-1.035,1.364-1.563
	C453.604,243.799,444.762,177.718,444.762,177.718z"
      />
      <g>
        <path
          fill="#847664"
          d="M375.21,302.167c-3.541,15.682,15.095,26.805,26.307,6.323
		c13.153-24.029,60.453-41.988,60.453-41.988C399.24,265.743,376.215,297.718,375.21,302.167z"
        />
        <path
          fill="#847664"
          d="M444.762,177.718C425.032,85.898,315,116.252,315,116.252c-47.807,11.383-56.913,65.26-56.913,65.26
		c1.518,16.188,38.954,37.942,38.954,37.942c18.719,7.588,24.282-9.106,24.282-9.106l14.67-26.812
		c18.213-24.789,32.631-18.718,36.425-18.718c30.858,0,48.059,30.101,61.718,30.101
		C447.796,194.918,444.762,177.718,444.762,177.718z"
        />
      </g>
      <path
        fill="#6D6256"
        d="M181.881,116.252c0,0-110.031-30.354-129.761,61.466c0,0-8.844,66.081,21.402,101.893
	c0.445,0.527,0.938,1.016,1.362,1.563c8.355,10.772,12.647,17.706,20.235,23.777c0,0,18.213,2.024,16.19-22.259
	c0,0-5.566-44.012,2.022-64.249c0,0,11.131-45.024,11.131-53.625c0,0,18.212-6.07,36.424,18.718l14.67,26.812
	c0,0,5.565,16.694,24.284,9.106c0,0,37.436-21.754,38.954-37.942C238.793,181.512,229.687,127.635,181.881,116.252z"
      />
      <g>
        <path
          fill="#847664"
          d="M120.95,302.167c-1.005-4.449-24.03-36.424-86.76-35.665c0,0,47.3,17.959,60.453,41.988
		C105.855,328.973,124.491,317.85,120.95,302.167z"
        />
        <path
          fill="#847664"
          d="M181.881,116.252c0,0-110.031-30.354-129.761,61.466c0,0-3.036,17.2,10.624,17.2
		c13.659,0,30.859-30.101,61.719-30.101c3.793,0,18.212-6.07,36.424,18.718l14.67,26.812c0,0,5.565,16.694,24.284,9.106
		c0,0,37.436-21.754,38.954-37.942C238.793,181.512,229.687,127.635,181.881,116.252z"
        />
      </g>
      <path
        fill="#B79563"
        d="M322.772,247.38c0,0,9.486-19.35,3.794-28.457c0,0-6.83-5.312-17.074-6.83
	c0,0-26.488-14.923-46.881-30.733c-3.725-2.889-10.014-3.034-13.795-3.035h-0.031c-3.782,0.001-10.071,0.146-13.796,3.035
	c-20.393,15.81-46.881,30.733-46.881,30.733c-10.244,1.518-17.074,6.83-17.074,6.83c-5.691,9.106,3.795,28.457,3.795,28.457
	c1.896,7.588-1.897,23.524-1.897,23.524c-4.173,27.698,9.865,35.666,9.865,35.666c10.624,6.83,13.658,29.595,13.658,29.595
	c1.518,11.382,6.83,28.835,6.83,28.835c3.035,5.312,30.354,32.63,30.354,32.63c6.762,9.016,14.999,6.877,15.161,6.833
	c0.164,0.044,8.401,2.182,15.162-6.833c0,0,27.319-27.318,30.354-32.63c0,0,5.313-17.453,6.831-28.835
	c0,0,3.034-22.765,13.658-29.595c0,0,14.039-7.968,9.865-35.666C324.669,270.904,320.875,254.968,322.772,247.38z"
      />
      <path
        fill="#AA885B"
        d="M248.816,178.326h-0.031c-3.782,0.001-10.071,0.146-13.796,3.035
	c-20.393,15.81-46.881,30.733-46.881,30.733c-10.244,1.518-17.074,6.83-17.074,6.83c-5.691,9.106,3.795,28.457,3.795,28.457
	c1.896,7.588-1.897,23.524-1.897,23.524c-4.173,27.698,9.865,35.666,9.865,35.666c10.624,6.83,13.658,29.595,13.658,29.595
	c1.518,11.382,6.83,28.835,6.83,28.835c3.035,5.312,30.354,32.63,30.354,32.63c6.762,9.016,14.999,6.877,15.161,6.833
	C248.964,404.507,248.785,178.326,248.816,178.326z"
      />
      <path
        fill="#E0C199"
        d="M247.709,304.556c-48.099,0-51.254,31.608-51.254,31.608c1.518,11.382,6.83,28.835,6.83,28.835
	c3.035,5.312,30.354,32.63,30.354,32.63c6.762,9.016,14.999,6.877,15.161,6.833c0.164,0.044,8.401,2.182,15.162-6.833
	c0,0,27.319-27.318,30.354-32.63c0,0,5.313-17.453,6.831-28.835C301.145,336.164,295.808,304.556,247.709,304.556z"
      />
      <path
        fill="#9E7F56"
        d="M248.785,387.421c-29.595,0-45.5-22.422-45.5-22.422c3.035,5.312,30.354,32.63,30.354,32.63
	c6.762,9.016,14.999,6.877,15.161,6.833c0.164,0.044,8.401,2.182,15.162-6.833c0,0,27.319-27.318,30.354-32.63
	C294.315,364.999,278.38,387.421,248.785,387.421z"
      />
      <g>
        <path
          fill="#494949"
          d="M191.65,228.409l-22.006-0.759c0,0-1.518,1.645-0.253,9.612c1.265,7.968,5.439,10.118,5.439,10.118
		l29.72,12.648l1.771-3.036L191.65,228.409z"
        />
        <path
          fill="#494949"
          d="M327.957,227.65l-22.006,0.759l-14.671,28.583l1.771,3.036l29.72-12.648
		c0,0,4.173-2.149,5.438-10.118C329.476,229.294,327.957,227.65,327.957,227.65z"
        />
        <path
          fill="#494949"
          d="M280.332,332.534c-14.991-7.623-30.614-9.561-31.272-9.639c-0.088-0.012-0.172,0.019-0.261,0.023
		c-0.087-0.004-0.171-0.035-0.26-0.023c-0.657,0.078-16.281,2.016-31.271,9.639c-0.493,0.251-0.811,0.75-0.83,1.302
		c-0.018,0.553,0.266,1.072,0.74,1.355l30.764,18.339c0.24,0.143,0.508,0.214,0.777,0.214c0.027,0,0.054-0.009,0.08-0.01
		c0.027,0.001,0.054,0.01,0.082,0.01c0.268,0,0.537-0.071,0.777-0.214l30.764-18.339c0.474-0.283,0.758-0.802,0.74-1.355
		C281.143,333.284,280.826,332.785,280.332,332.534z"
        />
        <path
          fill="#494949"
          d="M327.957,227.65l-0.042,0.002c0.407,1.254,0.674,2.605,0.796,4.014
		C328.696,228.462,327.957,227.65,327.957,227.65z"
        />
        <path
          fill="#494949"
          d="M281.348,364.701c-0.36-0.82-1.317-1.191-2.136-0.832c-10.592,4.661-18.443,5.263-23.34,1.787
		c-4.046-2.872-5.281-8.063-5.635-11.596c0.168-2.229,0.031-3.815,0.014-3.993c-0.08-0.831-0.775-1.449-1.587-1.46
		c-0.004,0-0.009-0.002-0.014-0.002c-0.891-0.081-1.674,0.592-1.747,1.485c-0.015,0.178-0.131,1.778,0.069,4.022
		c-0.304,3.5-1.461,8.609-5.427,11.489c-4.874,3.537-12.816,2.954-23.607-1.735c-0.821-0.359-1.776,0.019-2.132,0.841
		c-0.358,0.821,0.019,1.776,0.84,2.132c6.543,2.844,12.212,4.267,16.967,4.267c3.904,0,7.191-0.959,9.837-2.88
		c2.56-1.858,4.174-4.37,5.193-6.931c1.057,2.591,2.719,5.132,5.337,6.995c2.639,1.878,5.888,2.817,9.726,2.817
		c4.726,0,10.344-1.424,16.812-4.27C281.336,366.477,281.709,365.52,281.348,364.701z"
        />
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}

export default Aries;
